/**
    @71156: Listagem de Agro visita
 */
<template>
    <div id="main">
        <div class="page" v-show="!rotaAninhada">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("agro-visita") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t("agro") }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t("agro-visita") }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">

                        <!-- BOTÕES DA EXPORTAÇÃO -->
                        <div v-if="exportacaoTipo && permissao.export" class="column is-3">
                            <div class="exportIcons" style="justify-content: flex-end">
                                <div
                                    v-if="exportacaoTipo.exportaemail == 1"
                                    class="export-icon"
                                    @click="checkExport('email')"
                                >
                                    <b-icon
                                        icon="email-outline"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy :title="$t('msg-tooltip-email')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportawhatsapp == 1"
                                    class="export-icon"
                                    @click="checkExport('whatsapp')"
                                >
                                    <b-icon
                                        icon="whatsapp"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-whatsapp')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportapdf == 1"
                                    class="export-icon"
                                    @click="checkExport('pdf')"
                                >
                                    <b-icon
                                        icon="file-pdf"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-pdf')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportaexcel == 1"
                                    class="export-icon"
                                    @click="checkExport('excel')"
                                >
                                    <b-icon
                                        icon="file-excel"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-excel')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportacsv == 1"
                                    class="export-icon"
                                    @click="checkExport('csv')"
                                >
                                    <b-icon
                                        icon="file"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-csv')"
                                    />
                                </div>
                            </div>
                        </div>

                        <button
                            v-if="permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'agro-visita-new' })"
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-5">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                        />
                    </div>
                    <div class="column is-4">
                        <vss-select
                            ref="empresaInput"
                            title="empresa"
                            placeholder="selecione"
                            :options="empresaSelect"
                            v-model="empresaSelected"
                            :height="40"
                            :loading="empresasLoading"
                            @search="carregarEmpresas"
                            multiple
                        />
                    </div>
                    <div class="column is-3">
                        <vss-select
                            ref="safraInput"
                            title="safra"
                            placeholder="selecione"
                            :options="safraSelect"
                            @search="loadSafras"
                            v-model="safraSelected"
                            :height="40"
                            clearable
                            multiple
                            searchable
                            :closeOnSelect="false"
                        />
                    </div>
                </div>

                <!-- FILTROS EXTRAS -->
                <div class="filtros-extras">
                    <FiltroAgroVisita 
                        @update-filtro="updateFiltro" 
                        ref="filtroRef" 
                        :limparFiltros="limparFiltros" 
                        @filtrosLimpos="limparFiltros = $event"
                    />
                </div>

                <!-- BOTÕES -->
                <div class="columns mt-2 mb-1">
                    <div class="column is-6 has-text-centered">
                        <button class="delete-btn pl-4 pr-4" @click="confirmCleanFilters">
                            {{ $t("limpar-filtros") }}
                        </button>
                    </div>
                    <div class="column is-6 has-text-centered">
                        <button class="save-btn pl-4 pr-4" @click="carregarDados()">
                            {{ $t("pesquisar") }}
                        </button>
                    </div>
                </div>

                <!-- LISTAGEM -->
                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="agrovisitas"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <template v-for="(f, i) in fields">
                            <b-table-column
                                :key="i"
                                :field="f.key"
                                :label="f.key"
                                :width="f.width"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                            >
                                <!-- Cabeçalho da listagem -->
                                <template v-slot:header="{ column }">
                                    <span v-if="column.label == 'cliente'">
                                        {{ $t("cliente") }}
                                        <div class="table-sep" />
                                        {{ $t("talhao") }}
                                    </span>
                                    <span v-else-if="column.label == 'cultura'">
                                        {{ $t("cultura") }}
                                        <div class="table-sep" />
                                        {{ $t("motivo-visita") }}
                                    </span>
                                    <span v-else-if="column.label == 'propriedade'">
                                        {{ $t("propriedade") }}
                                        <div class="table-sep" />
                                        {{ $t("datavisita") }}
                                    </span>
                                    <span v-else-if="column.label == 'codigo'">
                                        {{ $t("situacao") }}
                                        <div class="table-sep" />
                                        {{ $t("codigo") }}
                                    </span>
                                    <span v-else>
                                        {{ column.label ? $t(column.label) : "" }}
                                    </span>
                                </template>
                                <!-- Dados da listagem -->
                                <template v-slot="props">
                                    <div v-if="f.key == 'cliente'">
                                        <router-link
                                            :to="{
                                                name: 'agro-visita-edit',
                                                params: { id: props.row.uuid },
                                            }"
                                        >
                                            <strong>{{ props.row.cliente }}</strong>
                                        </router-link>
                                        <div class="table-sep" />
                                        {{ props.row.talhao }}
                                    </div>
                                    <div v-else-if="f.key == 'cultura'">
                                        <strong>{{ props.row.cultura }}</strong>
                                        <div class="table-sep" />
                                        {{ props.row.motivovisita }}
                                    </div>
                                    <div v-else-if="f.key == 'propriedade'">
                                        <strong>{{ props.row.propriedade }}</strong>
                                        <div class="table-sep" />
                                        {{ $moment(props.row.datahora).format("L LT") }}
                                    </div>
                                    <div v-else-if="f.key == 'codigo'">
                                        <span 
                                            class="tag"
                                            :class="{
                                                'is-warning': props.row.situacao == 'E',
                                                'is-orange': props.row.situacao == 'criacao',
                                                'is-success': props.row.situacao == 'finalizada',
                                                'is-danger': props.row.situacao == 'inativo',
                                            }"
                                        >
                                            {{ $t(props.row.situacao) }}
                                        </span>
                                        <div class="has-text-centered mt-2" :title="props.row.uuid">
                                            {{ props.row[f.key] }}
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{ props.row[f.key] }}
                                    </div>
                                </template>
                            </b-table-column>
                        </template>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <b-modal
            class="export-opcoes"
            :active.sync="isShowingTitle"
            style="z-index: 1000"
            @close="isShowingTitle = false"
        >
            <div class="modal-card modal-default center" style="max-width: 580px">
                <section class="modal-card-body">
                    <div class="listing-header">
                        <div class="title-breadcrumb center">
                            <h1 class="title">{{ $t("exportacao-dados") }}</h1>
                        </div>
                    </div>
                    <div class="columns p-4">
                        {{ $t("title-exp") }}
                    </div>
                    <div class="columns is-full mx-1">
                        <div class="titulo-input">
                            <v-input
                                v-model="tituloExportacao"
                                :maxlength="100"
                                :title="'titulo-exp'"
                                :msg="'msg-campo-obrigatorio'"
                            />
                        </div>
                    </div>
                    <div class="columns ok">
                        <div class="form-buttons2">
                            <button
                                class="delete-btn"
                                type="button"
                                @click="isShowingTitle = false"
                            >
                                {{ $t("cancelar") }}
                            </button>
                            <button
                                class="save-btn"
                                type="button"
                                @click="saveExportacao()"
                            >
                                {{ $t("exportar-rel") }}
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>
        <router-view />
    </div>
</template>

<script>
import AgroVisitaService from "@/services/agro/agrovisita/AgroVisitaService";
import SafraService from "@/services/agro/SafraService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import FiltroAgroVisita from "@/components/agro/agro-visita/FiltroAgroVisita.vue";
import ExportacaoTipoService from "@/services/ExportacaoTipoService";
import ExportacaoService from "@/services/ExportacaoService";
import ExportacaoLogService from "@/services/ExportacaoLogService";
import ExportacaoDadosService from "@/services/ExportacaoDadosService";

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("agro-visita") && to.name != "agro-visita-list") {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
        FiltroAgroVisita,
    },
    data() {
        return {
            rotaAninhada: false,
            agrovisitas: [],
            service: new AgroVisitaService(this.$http, this.$router),
            safraService: new SafraService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            exportacaoTipoService: new ExportacaoTipoService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http, this.$router),
            exportacaoDadosService: new ExportacaoDadosService(
                this.$http,
                this.$router
            ),
            fields: [
                { key: "propriedade", width: null, sortable: false, sortFn: null },
                { key: "cliente", width: null, sortable: false, sortFn: null },
                { key: "cultura", width: null, sortable: false, sortFn: null },
                { key: "codigo", width: null, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",
            delete: null,
            permissao: {},
            order: "desc",
            column: "datahora",
            searchQuery: "",
            empresaSelect: [],
            empresaSelected: [],
            safraSelect: [],
            safraSelected: [],
            params: "",
            filtros: {
                cliente: [],
                propriedade: [],
                area: [],
                talhao: [],
                usuario: [],
                cultura: [],
                motivosvisita: [],
                assuntosvisita: [],
                tipoocorrencia: [],
                dataInicio: new Date(this.$moment().subtract(30, "days")),
                dataFim: new Date(),
                status: 0,
            },
            limparFiltros: false,
            exportacaoTipo: {},
            exportWithPhoto: false,
            isShowingTitle: false,
            tituloExportacao: null,
            empresasLoading: false,
        };
    },
    created() {
        this.rotaAninhada = (this.$route.name != 'agro-visita-list');

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-visita",
            "agro-visita"
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-visita" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregaExportacaoTipo();
            this.carregarDados();
            this.carregarEmpresas("");
            // já carrega pelo @search="loadSafras"
            // this.loadSafras();
        }
    },
    methods: {
        updateFiltro(filtro) {
            switch (filtro.nomeFiltro) {
                case "cliente":
                    this.filtros.cliente = filtro.valor;
                    break;
                case "propriedade":
                    this.filtros.propriedade = filtro.valor;
                    break;
                case "area":
                    this.filtros.area = filtro.valor;
                    break;
                case "talhao":
                    this.filtros.talhao = filtro.valor;
                    break;
                case "usuario":
                    this.filtros.usuario = filtro.valor;
                    break;
                case "cultura":
                    this.filtros.cultura = filtro.valor;
                    break;
                case "tipoocorrencia":
                    this.filtros.tipoocorrencia = filtro.valor;
                    break;
                case "motivosvisita":
                    this.filtros.motivosvisita = filtro.valor;
                    break;
                case "assuntovisita":
                    this.filtros.assuntosvisita = filtro.valor;
                    break;
                case "inicio":
                    this.filtros.dataInicio = filtro.valor;
                    break;
                case "fim":
                    this.filtros.dataFim = filtro.valor;
                    break;
            }
        },
        limparFiltrosCall() {
            this.empresaSelected = [];
            this.safraSelected = [];
            this.filtros.cliente = [];
            this.filtros.propriedade = [];
            this.filtros.area = [];
            this.filtros.talhao = [];
            this.filtros.usuario = [];
            this.filtros.cultura = [];
            this.filtros.motivosvisita = [];
            this.filtros.assuntosvisita = [];
            this.filtros.tipoocorrencia = [];
            this.filtros.dataInicio = new Date(this.$moment().subtract(30, "days"));
            this.filtros.dataFim = new Date();
            this.filtros.status = 0;
            this.limparFiltros = true;
            this.carregarDados();
        },
        confirmCleanFilters() {
            this.$root.confirm({
                message: this.$t("msg-confirm-limpar-filtros"),
                onConfirm:() => this.limparFiltrosCall(),
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
                
            this.isLoading = true;

            let filtros = this.geraFiltros();

            let params = [this.queryFilter != "" ? this.queryFilter : ".*"];
            
            this.service.findAll(
                filtros,
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                params
            )
            .then(this.mapItems)
            .then(value => {
                this.agrovisitas = value;
                this.isEmpty = this.agrovisitas.length <= 0;
            })
            .catch((e) => {
                this.isEmpty = true;
                this.$root.showMessage("error", "msg-erro-load");
                console.error("Erro ao carregar as Agrovisitas.");
            })
            .finally(() => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        geraFiltros(){
            return {
                empresas: this.empresaSelected
                    ? this.empresaSelected.map((e) => e.id) : [],
                safras: this.safraSelected 
                    ? this.safraSelected.map((e) => e.id)  : [],
                clientes: this.filtros.cliente
                    ? this.filtros.cliente.map((e) => e.idcliente) : [],
                propriedades: this.filtros.propriedade
                    ? this.filtros.propriedade.map((e) => e.uuid) : [],
                areas: this.filtros.area
                    ? this.filtros.area.map((e) => e.uuid) : [],
                talhoes: this.filtros.talhao
                    ? this.filtros.talhao.map((e) => e.uuid) : [],
                culturas: this.filtros.cultura
                    ? this.filtros.cultura.map((e) => e.id) : [],
                motivosvisita: this.filtros.motivosvisita
                    ? this.filtros.motivosvisita.map((e) => e.id) : [],
                assuntosvisita: this.filtros.assuntosvisita
                    ? this.filtros.assuntosvisita.map((e) => e.id) : [],
                tipoocorrencia: this.filtros.tipoocorrencia
                    ? this.filtros.tipoocorrencia.map((e) => e.id) : [],
                usuarios: this.filtros.usuario
                    ? this.filtros.usuario.map((e) => e.id) : [],
                inicio: this.filtros.dataInicio
                    ? this.$moment(this.filtros.dataInicio).format("YYYY-MM-DD")
                    : null,
                fim: this.filtros.dataFim
                    ? this.$moment(this.filtros.dataFim).add(1, "days").format("YYYY-MM-DD")
                    : null,
            };
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map(m => {
                let situacao = '';
                if(m.situacao == 4) {
                    situacao = 'criacao'
                } else if (m.situacao == 1) {
                    situacao = 'finalizada'
                } else {
                    situacao = 'inativo'
                }
                return {
                    propriedade: m.propriedade?m.propriedade.nome:'---',
                    datahora: m.datahora,
                    cliente: m.cliente?m.cliente.nome:'---',
                    talhao: m.talhao?m.talhao.descricao:'---',
                    cultura: m.cultura?m.cultura.descricao:'---',
                    motivovisita: m.motivovisita?m.motivovisita.descricao:'---',
                    codigo: m.idagro_visitaerp,
                    situacao: situacao,
                    uuid: m.uuid,
                };
            });
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService.findList(q)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`[AGRO VISITA] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[AGRO VISITA] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                        return {
                            id: e.idempresa,
                            label: e.nome,
                        };
                    });
                    }
                })
                .catch(e => {
                    console.error('[AGRO VISITA] Erro ao carregar empresas.', e);
                })
                .finally(_ => {
                    this.empresasLoading = false;
                });
        },
        // Carregar as safras para serem exibidas no filtro por safras
        loadSafras(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.isLoading = true;
            this.safraService
                .findAllComboSituacao(2, query)
                .then(this.mapSafras)
                .then((value) => {
                    this.safraSelect = value;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        mapSafras(body) {
            return body.content.map((i) => {
                return {
                    id: i.idsafra,
                    label: i.situacao != 1 ? 'Inativo | '+ i.descricao : i.descricao,
                    situacao: i.situacao
                };
            });
        },
        carregaExportacaoTipo() {
            // Inidica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela("AGROVISITA")
                .then((body) => {
                    if (body.content) {
                        this.exportacaoTipo = body.content;
                    }
            });
        },
        checkExport(tipo) {
            this.exportWithPhoto = false;
            this.tipoExportacao = tipo;

            if (
                this.empresaSelected.length==0||this.filtros.dataInicio==null||this.filtros.dataFim==null
            ) {
                let msg = this.$t(
                    'preencha-campos-obrigatorios-n', {
                        n: this.$t('empresa')+', '+
                        this.$t('data-inicio')+' e '+
                        this.$t('data-final')
                    })

                this.$root.showMessage('alert', msg, true, false);

            }else{
                if(tipo=='pdf'){
                    this.promptExportPdf();
                }else{
                    this.isShowingTitle = true;
                }
            }
        },
        // pedir se quer fotos se for pda
        promptExportPdf() {
            this.$root.confirm({
                message: this.$t("gerar-com-fotos"),
                onConfirm: () => {
                    this.exportWithPhoto = true;
                    this.isShowingTitle = true;
                },
                onCancel: () => {
                    this.exportWithPhoto = false;
                    this.isShowingTitle = true;
                },
            });
        },
        saveExportacao() {
            if(this.isNull(this.tituloExportacao)){
                this.$root.showMessage('alert', "msg-valida-titulo");
            }else{
                this.isSaving = true;
                this.isShowingTitle = false;

                let exportacao = {
                    idexportacao: null,
                    titulo: this.tituloExportacao,
                    processoexportado: this.tipoExportacao,
                    situacao: "EXPORTANDO",
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    },
                    exportacaotipo: {
                        idexportacaotipo: this.exportacaoTipo.idexportacaotipo, //IDEXPORTACAOTIPO (REFERE-SE A QUAL TELA ESTA CHAMANDO A EXPORTACAO)
                    },
                };

                // salva o inicio da gração em fvw_exportacao
                this.exportacaoService
                    .save(exportacao)
                    .then(response => {
                        this.$root.showMessage("success", "msg-exp-solicitada");
                        this.saveLog(response.content, this.tipoExportacao);

                        this.gerarArquivoExportacao(response.content);
                    })
                    .catch((e) => {
                        console.error("Erro ao salvar exportação.", e);
                        this.$root.showMessage("error", "msg-erro-exp-gerar");
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            }
        },
        // Salva os dados na tabela fvw_exportacaolog
        saveLog(exportacao, tipo) {
            let exportacaoLog = {
                ///Objeto criado que será enviado ao banco
                destino: null,
                acao: "Solicitação da exportação listagem " + tipo,
                exportacao: exportacao,
                usuario: {
                    idusuarioerp: exportacao.usuario.idusuarioerp,
                },
            };
            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    console.error("Erro ao salvar log exportação.", e);
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                })
        },
        gerarArquivoExportacao(exportacao) {
            let exportacaoAgroVisita = {
                exportacao: exportacao,
                filtro: this.geraFiltros(),
                exportafoto: this.exportWithPhoto,
                usuario: this.$store.state.user,
            }
            let params = [this.queryFilter != "" ? this.queryFilter : ".*"];
            
            this.exportacaoDadosService
                .saveAgroVisitaList(
                    exportacaoAgroVisita, 
                    this.tipoExportacao, 
                    this.column,
                    this.order,
                    params
                )
                .then(this.tituloExportacao = "")
                .catch((e) => {
                    console.error("Erro ao salvar exportação ", this.tipoExportacao, e);
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .status-tag {
        margin-top: 10px;
    }

    .datepicker input {
        height: 40px !important;
    }

    .tag {
        width: 100%;
        margin-bottom: 2px;
    }

    .is-orange {
        background-color: #ef8419;
        color: #fff;
    }

    .exportIcons {
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
    }

    .export-icon {
        color: var(--primary-color);
        padding-right: 1rem;
    }
    .modal {
        display: flex;
        justify-content: center;
    }
    .modal-content {
        width: 40% !important;
    }
    .modal-card {
        width: auto !important;
    }
    .titulo-input {
        width: 100%;
    }
    .form-buttons2 {
        top: 20px;
        display: flex;
        margin: 0 auto;

        .save-btn,
        .delete-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $sovis-white;
            font-size: 12px;
            height: 47px;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px !important;
            @include gradient-button();
        }

        .delete-btn {
            right: 225px;
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
    .ok {
        margin: 0;
    }
}
</style>